const initState = {
  isLogin: false,
};
const reducer = (state = initState, action) => {
  // console.log("ruducer:", state, action);
  switch (action.type) {
    case "SETLOGIN":
      return Object.assign({}, state, { isLogin: action.value });
    default:
      return state;
  }
};

export default reducer;
